module.exports = __webpack_public_path__ + "static/media/checkmark.0edc08d3.svg";